import React, { useState, useEffect } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../ProgressBar";
import NextBackButton from "../NextBackButton";

export const WhereAreYouLooking = ({ formData, setForm, navigation }) => {
  const { city, state } = formData;
  const [stateArray, setStateArray] = useState([]);
  const [cityError, setCityError] = useState(false);
  const [stateError, setStateError] = useState(false);

  const [isVisible, setIsVisible] = useState(true);
  const [toolTip, setToolTip] = useState(false);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  useEffect(() => {
    let statesList = getStatesList();
    async function getStatesList() {
      // graphql query string to get list of states
      const statesListQuery = `{
      statesList {
        abbreviation
        name
      }
    }`;

      const res = await fetch("https://graphql-onetrust.herokuapp.com/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query: statesListQuery }),
      });

      const statesList = await res.json();
      setStateArray(statesList.data.statesList);
      return statesList;
    }
  }, []);
  console.log(stateArray);

  const checkForNextStep = () => {
    if (formData.city === "") {
      setCityError(true);
      console.log("error");
    }
    if (formData.state === "") {
      setStateError(true);
      console.log("error");
    }

    if (formData.state !== "" && formData.city !== "") {
      navigation.next();
      console.log("next");
    }
  };

  function leaveToolTip() {
    setTimeout(() => {
      setToolTip(false);
    }, 2000);
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const city = decodeURIComponent(urlParams.get("city") || "");
    const state = decodeURIComponent(urlParams.get("state") || "");

    console.log(city, state);

    if (city) {
      setForm({ target: { name: "city", value: city } });
    }

    const validState = abbreviateStateName(state);
    if (validState) {
      setForm({ target: { name: "state", value: validState } });
    }

    console.log(city, state);
  }, [stateArray]);

  // if state is not abbreviated, return the abbreviation. if abbreviated, leave as is
  function abbreviateStateName(state) {
    if (!state || stateArray.length === 0) return null;

    const normalizedState = state.toLowerCase();
    const findState = stateArray.find((s) => s.name.toLowerCase() === normalizedState);

    if (findState) {
      return findState.abbreviation.toUpperCase();
    } else if (state.length === 2 && stateArray.some((s) => s.abbreviation === state.toUpperCase())) {
      return state.toUpperCase();
    } else {
      console.log(`State name not found: ${state}`);
      return null;
    }
  }

  return (
    <div className="flex flex-col h-screen w-full">
      <ProgressBar width={"10%"} />
      <div className="flex-grow max-w-7xl mx-auto sm:px-6 lg:px-8 flex justify-center items-center">
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className="mx-auto">
              <h1 className="pb-10 text-4xl text-blue-primary font-semibold text-center">
                Where are you looking to build a home?
              </h1>
              <div className="flex justify-evenly flex-col space-y-8 mx-auto">
                <div>
                  <div className="flex justify-center">
                    <input
                      name="city"
                      value={city}
                      onChange={setForm}
                      id="city"
                      className="shadow-sm border focus:ring-green-primary focus:border-green-primary block max-w-[250px] lg:w-full text-xl font-semibold border-gray-300 rounded-md w-52 md:w-60 py-1 px-2"
                      placeholder="City"
                    />
                  </div>
                  {cityError ? <p className="text-red-error text-center">Please fill out an answer</p> : null}
                </div>
                <div className="">
                  <div className="flex justify-center ml-14">
                    <select
                      name="state"
                      value={state}
                      onChange={setForm}
                      id="state"
                      className="shadow-sm border focus:ring-green-primary focus:border-green-primary block w-full text-xl font-semibold border-gray-300 rounded-md w-52 md:w-60 py-1 px-2"
                    >
                      {stateArray.map((state) => (
                        <option key={state.abbreviation} value={state.abbreviation}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                    <div
                      onMouseEnter={() => setToolTip(true)}
                      onMouseLeave={leaveToolTip}
                      className="rounded-full bg-blue-primary h-8 w-8 text-center text-white text-xl border border-green-primary ml-6"
                    >
                      {toolTip ? (
                        <div
                          onMouseEnter={() => setToolTip(true)}
                          className="tooltip text-center w-72 mx-auto mt-4 text-left bg-blue-primary absolute z-50  top-[95px] right-[60px] md:right-[-140px] md:top-[85px] ml-8 rounded"
                        >
                          <p className="text-sm text-white p-4">
                            We are able to provide home financing solutions to clients in the states in which we are
                            licensed as CalCon Mutual Mortgage. Please see our{" "}
                            <a
                              target="_blank"
                              className="text-green-primary underline font-semibold"
                              href="https://onetrusthomeloans.com/licensing-information/"
                            >
                              Locations & Licensing
                            </a>{" "}
                            page for more details.
                          </p>
                        </div>
                      ) : null}
                      ?
                    </div>
                  </div>
                  {stateError ? <p className="text-red-error text-center">Please fill out an answer</p> : null}
                </div>
              </div>
            </animated.div>
          ) : null
        )}
      </div>

      <NextBackButton callBack={checkForNextStep} goBack={() => navigation.previous()} showBackButton={false} />
    </div>
  );
};
